// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__Bv8by","topBottomGutter":"Layout_topBottomGutter__1c2vk"};